/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";

const pincodeCall = async (pincode: string) => {
  try {
    const response = await axiosInstance.get(API_URLS.masters.pincode, {
      params: {
        pincode
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const getAllBranchNames = async (channel: string) => {
  try {
    const response: any = await axiosInstance.get(
      `${API_URLS.masters.branchName}?channel=${channel}`
    );
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const genderDetails = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.gender);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};
const relationshipDetails = async (type: string) => {
  try {
    const response: any = await axiosInstance.get(`${API_URLS.relationship}?type=${type}`);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const educationDetails = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.education);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const occupationDetails = async (type: string) => {
  try {
    const response: any = await axiosInstance.get(API_URLS.occupation, {
      params: {
        type
      }
    });
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const salutationDetails = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.salutation);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const maritalStatusDetails = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.marital_status);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const subOccupationDetails = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.sub_occupation);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const subOccupationCall = async (params: Record<string, any>) => {
  try {
    const response = await axiosInstance.get(API_URLS.masters.subOccupation, {
      params
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const countryCall = async (params: Record<string, any>) => {
  try {
    const response = await axiosInstance.get(API_URLS.masters.country, {
      params
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const policyStatusDetails = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.masters.policyStatus);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const insuranceCompanyDetails = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.masters.insuranceCompany);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const callRuleEngine = async (
  productId: string,
  partnerId: string,
  loanType: string,
  isOldQuestionnaire: boolean
) => {
  try {
    const response: any = await axiosInstance.get(
      `${API_URLS.masters.rule_engine}?productId=${productId}&partnerId=${partnerId}&loanType=${loanType}&isOldQuestionnaire=${isOldQuestionnaire}`
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error);
  }
};

const callPartnerConfig = async (code: string) => {
  try {
    const response: any = await axiosInstance.get(API_URLS.masters.partner, {
      params: {
        code
      }
    });
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const getAllPartners = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.masters.allPartners);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const product = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.masters.allProduct);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const channel = async () => {
  try {
    const response: any = await axiosInstance.get(API_URLS.masters.channel);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const getMefJourneySchema = async (productId: string, partnerId: string, loanType: string) => {
  try {
    const response: any = await axiosInstance.get(
      `${API_URLS.getMefJourneySchema}?productId=${productId}&partnerId=${partnerId}&loanType=${loanType}`
    );

    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const deleteAssignmentDetails = async (id: string) => {
  try {
    const response = await axiosInstance.post(`${API_URLS.deleteAssignment}?id=${id}`);
    return response.data;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const ifscExistCall = async (ifsc: string) => {
  try {
    const response = await axiosInstance.get(API_URLS.masters.ifscExist, {
      params: {
        ifsc
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export {
  genderDetails,
  relationshipDetails,
  educationDetails,
  occupationDetails,
  salutationDetails,
  maritalStatusDetails,
  subOccupationDetails,
  subOccupationCall,
  pincodeCall,
  countryCall,
  policyStatusDetails,
  insuranceCompanyDetails,
  callRuleEngine,
  product,
  channel,
  callPartnerConfig,
  getAllPartners,
  getMefJourneySchema,
  getAllBranchNames,
  deleteAssignmentDetails,
  ifscExistCall
};
